import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const items = [
  "Volledige inventarisatie van je huidige ICT-omgeving",
  "Inrichting van je Microsoft 365-omgeving met beveiligingsbeleid",
  "Migratie van e-mail, agenda's en contacten",
  "Migratie van bestanden naar OneDrive en SharePoint",
  "Configuratie van tweestapsverificatie en voorwaardelijke toegang",
  "Inrichting van al je apparaten via Microsoft Intune",
  "DNS-omzetting en domeinverificatie",
  "Testen en validatie van de volledige omgeving",
  "Schone herinstallatie van bestaande computers",
  "Overname domeinbeheer (DNS) waar mogelijk",
  "Doorlopende back-ups vanaf dag één actief",
  "Begeleiding op de dag van de overstap",
];

const MigrationChecklist = () => {
  return (
    <section className="bg-muted/40 py-16 md:py-24">
      <div className="container">
        <motion.div
          className="mx-auto max-w-3xl"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-center text-2xl font-bold md:text-3xl">
            Wat zit er in de{" "}
            <span className="text-gradient">implementatie?</span>
          </h2>
          <p className="mt-4 text-center text-lg text-muted-foreground">
            De eenmalige kosten van <span className="font-semibold text-foreground">€ 225,00 per werkplek</span> omvatten:
          </p>

          <div className="mt-10 grid gap-3 sm:grid-cols-2">
            {items.map((item, i) => (
              <motion.div
                key={item}
                className="flex items-start gap-3 rounded-lg border border-border bg-card p-4"
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3, delay: i * 0.04 }}
              >
                <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-rinqel-green" />
                <span className="text-sm">{item}</span>
              </motion.div>
            ))}
          </div>

          {/* Geen kosten bij uitbreiding */}
          <motion.div
            className="mt-10 rounded-xl border border-secondary/20 bg-gradient-to-br from-secondary/5 to-secondary/10 p-6 md:p-8 text-center"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <h3 className="text-lg font-bold md:text-xl">
              Groeit je team?{" "}
              <span className="text-gradient">Geen extra kosten!</span>
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground md:text-base">
              Komt er later een nieuwe medewerker bij? Dan betaal je geen implementatiekosten.
              Er hoeft namelijk geen data verhuisd te worden — we maken gewoon een fris account aan en het apparaat wordt automatisch ingericht. Klaar!
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default MigrationChecklist;
